import Fuse from 'fuse.js'
import type { Product } from '../types/product'

const choseong = ['ㄱ','ㄲ','ㄴ','ㄷ','ㄸ','ㄹ','ㅁ','ㅂ','ㅃ','ㅅ','ㅆ','ㅇ','ㅈ','ㅉ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ']
export const toChoseong = (text: string) => [...text].map((char) => {
  const code = char.charCodeAt(0) - 0xac00
  return code >= 0 && code <= 11171 ? choseong[Math.floor(code / 588)] : char
}).join('')

export function searchProducts(products: Product[], query: string) {
  const clean = query.trim()
  if (!clean) return products
  const enriched = products.map((product) => ({ ...product, choseong: toChoseong([product.name, ...product.keywords].join(' ')), searchableIngredients: product.ingredients.map((item) => item.name).join(' ') }))
  if (/^[ㄱ-ㅎ]+$/.test(clean)) return enriched.filter((item) => item.choseong.includes(clean))
  return new Fuse(enriched, { threshold: 0.38, ignoreLocation: true, keys: ['name','englishName','brand','shortDescription','seniorFriendlyCategory','officialCategory','keywords','searchableIngredients','packageRecognition.ocrKeywords'] }).search(clean).map((result) => result.item)
}
